<div
  class="panel rs-wd-s6 rs-wd-m10 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
></div>
<div class="panel rs-bg-grey1">
  <div class="rs-flex-row rs-flex-collapse rs-flex-middle">
    <div class="rs-flex-columns rs-flex-grow">
      <div
        class="panel rs-maxw rs-wd-m41 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading hide-for-medium-up"
      ></div>
      <div
        class="panel rs-maxw rs-wd-m41 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
      ></div>
    </div>
    <div class="rs-flex-columns">
      <div
        class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-margin-left1 rs-radius-circle rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
      ></div>
    </div>
  </div>
</div>
<div class="panel rs-bg-grey1">
  <div class="rs-flex-row rs-flex-collapse rs-flex-middle">
    <div class="rs-flex-columns rs-flex-grow">
      <div
        class="panel rs-maxw rs-wd-m41 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading hide-for-medium-up"
      ></div>
      <div
        class="panel rs-maxw rs-wd-m41 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
      ></div>
    </div>
    <div class="rs-flex-columns">
      <div
        class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-margin-left1 rs-radius-circle rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
      ></div>
    </div>
  </div>
</div>
<div class="panel rs-bg-grey1">
  <div class="rs-flex-row rs-flex-collapse rs-flex-middle">
    <div class="rs-flex-columns rs-flex-grow">
      <div
        class="panel rs-maxw rs-wd-m41 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading hide-for-medium-up"
      ></div>
      <div
        class="panel rs-maxw rs-wd-m41 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
      ></div>
    </div>
    <div class="rs-flex-columns">
      <div
        class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-margin-left1 rs-radius-circle rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
      ></div>
    </div>
  </div>
</div>
